export const SET_ONLINE_CHANNEL = 'SET_ONLINE_CHANNEL';
